// extracted by mini-css-extract-plugin
module.exports = {"bet-choice":"bet-options_bet-choice__2H5fj","small":"bet-options_small__qjN98","big":"bet-options_big__37d02","layout-BS":"bet-options_layout-BS__3-sFb"};